export default {
  fetched: false,
  roles: [],
  services: [],
  permissions: [],
  changes: [],
}
